/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Enablepushaction3Inputs */

const id_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Notifikasi Push`)
};

const ms_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Pemberitahuan Push`)
};

const da_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiver Push Notifikationer`)
};

const de_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-Benachrichtigungen aktivieren`)
};

const en_us2_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Push Notifications`)
};

const es_es2_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar notificaciones push`)
};

const es_mx2_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar notificaciones push`)
};

const fil_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-enable ang Push Notifications`)
};

const fr_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications push`)
};

const it_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita notifiche push`)
};

const hu_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push értesítések engedélyezése`)
};

const nl_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushmeldingen inschakelen`)
};

const no_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiver push-varsler`)
};

const pl_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz powiadomienia push`)
};

const pt_br2_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar notificações push`)
};

const pt_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar notificações push`)
};

const ro_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activează notificările push`)
};

const fi_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota push-ilmoitukset käyttöön`)
};

const sv_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivera push-notiser`)
};

const vi_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật thông báo đẩy`)
};

const tr_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push Bildirimlerini Etkinleştir`)
};

const cs_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povolit push oznámení`)
};

const bg_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активиране на push известия`)
};

const ru_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить push-уведомления`)
};

const uk_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути Push-сповіщення`)
};

const ar_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمكين الإشعارات الفورية`)
};

const hi_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुश सूचनाएँ सक्षम करें`)
};

const th_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดใช้งานการแจ้งเตือนแบบพุช`)
};

const ja_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知を有効にする`)
};

const zh_cn2_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用推送通知`)
};

const zh_hant1_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`啟用推播通知`)
};

const ko_offerdetail_notifications_enablepushaction3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림 활성화`)
};

/**
* | output |
* | --- |
* | "Enable Push Notifications" |
*
* @param {Offerdetail_Notifications_Enablepushaction3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_enablepushaction3 = /** @type {((inputs?: Offerdetail_Notifications_Enablepushaction3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Enablepushaction3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "da") return da_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "de") return de_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "it") return it_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "no") return no_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "th") return th_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_enablepushaction3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_enablepushaction3(inputs)
	return ko_offerdetail_notifications_enablepushaction3(inputs)
});
export { offerdetail_notifications_enablepushaction3 as "offerDetail.notifications.enablePushAction" }